import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../styles/LegalPages.css';

const NotFound = () => (
  <>
    <Helmet>
      <title>Seite nicht gefunden | DynaStoxx</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <div className="legal-container not-found">
      <div className="legal-card not-found-card">
        <i className="fas fa-compass not-found-icon" aria-hidden="true"></i>
        <h1>Seite nicht gefunden</h1>
        <p>Die aufgerufene Seite existiert nicht oder wurde verschoben.</p>
        <div className="not-found-actions">
          <Link to="/" className="app-btn app-btn--primary">
            <i className="fas fa-home" aria-hidden="true"></i> Zur Startseite
          </Link>
          <Link to="/search" className="app-btn app-btn--secondary">
            <i className="fas fa-search" aria-hidden="true"></i> Aktiensuche
          </Link>
        </div>
      </div>
    </div>
  </>
);

export default NotFound;
